export function formatDateToFrench(
  dateString: string | number | Date | undefined
) {
  // Créer une instance de la date
  const date = new Date(dateString ?? new Date());

  // Tableau des mois en français
  const mois = [
    "Janvier",
    "Février",
    "Mars",
    "Avril",
    "Mai",
    "Juin",
    "Juillet",
    "Août",
    "Septembre",
    "Octobre",
    "Novembre",
    "Décembre",
  ];

  // Obtenir le jour, le mois et l'année
  const jour = date.getDate().toString().padStart(2, "0");
  const moisEnLettres = mois[date.getMonth()];
  const annee = date.getFullYear();

  // Retourner la date formatée
  return `${jour} ${moisEnLettres} ${annee}`;
}

export function getHourFromDate(
  dateString: string | number | Date | undefined
) {
  // Créer une instance de la date
  const date = new Date(dateString ?? new Date());
  const hour = date.getHours();
  const minute = date.getMinutes();

  return `${hour}h${minute}`;
}

export const getDay = (dateString: string) => {
  const date = new Date(dateString ?? new Date());

  const day = date.getDate();
  // Gestion des suffixes
  let suffix = "" +
      ""; // Par défaut "ème" pour la plupart des nombres
  if (day === 1) {
    suffix = "er"; // Exception pour le 1er
  }

  return `${day}${suffix}`;
}

export const getMonth = (dateString: string) => {
  const date = new Date(dateString ?? new Date());
  const months = ["Jan", "Fev", "Mar", "Avr", "Mai", "Juin", "Jul", "Août", "Sep", "Oct", "Nov", "Déc"];
  const month = months[date.getMonth()];

  return `${month}`;
}
